// import React, { useState, useEffect } from 'react'
// import { Card, Row, Col, Typography, Select, Spin, Divider, Tabs, Result } from 'antd'
// import styled from 'styled-components'
// import { Link } from 'react-router-dom'
// import { useGetDashboardData } from 'src/cms/hooks/Individual/useGetDashboardData'
// import { FaCheckSquare, FaChild, FaFileAlt, FaFileArchive, FaPersonBooth } from 'react-icons/fa'
// import { key } from 'src/app/modules/siteSettings'
// import { IoPerson, IoPersonOutline } from 'react-icons/io5'
// import { MdCancel, MdCorporateFare, MdGroup } from 'react-icons/md'
// import { BiChild } from 'react-icons/bi'
// import { AiOutlineFileDone } from 'react-icons/ai'
// import { useSelector } from 'react-redux'

// const CardComponent = () => {
//   // const { data: DashboardData, isLoading } = useGetDashboardData('NewCIFNewAccount')
//   const roleName = useSelector((state: any) => state.auth?.rolePermissions?.name)
//   const isLoading = false
//   const DashboardData: any = {
//     data: {
//       "dashboard": {
//         "total_count": '-',
//         "total_completed": '-',
//         "total_rejected": '-',
//         "branch_maker": {
//           "individual": '-',
//           "joint": '-',
//           "minor": '-',
//           "corporate": '-'
//         },
//         "branch_checker": {
//           "individual": '-',
//           "joint": '-',
//           "minor": '-',
//           "corporate": '-'
//         },
//         "branch_manager": {
//           "individual": '-',
//           "joint": '-',
//           "minor": '-'
//         }
//       }
//     }
//   }

//   if (isLoading) {
//     return (
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '80vh', // Adjust as needed
//           width: '100%',
//         }}
//       >
//         <Spin tip='Loading...' size='large' fullscreen />
//       </div>
//     )
//   }
//   if (!roleName) {
//     return (
//       <div className='card customCard'>
//         <div className='card-body pt-3 '>
//           <Result
//             status='warning'
//             title='Role Not Found'
//             subTitle='Please Contact Central Operation'
//           />
//         </div>
//       </div>
//     )
//   }
//   const colors = ['card-grey', 'card-blue', 'card-purple', 'card-light-green']

//   return (
//     <div className='mt-4' >
//       <section className='mb-4'>
//         <h3 className='title'>Branch Details</h3>
//         <Divider className='m-0 mb-2' />
//         <div className='row'>
//           <div className='col-lg-3 col-md-6 my-2'>
//             <Link
//               to={
//                 roleName?.toLowerCase()?.includes('ro')
//                   ? '/quick-account-opening'
//                   : '/account-opening-status'
//               }
//             >
//               <a className={`quick-action-card card-amber`}>
//                 <div className='card-body'>
//                   <div className='d-flex justify-content-between align-items-center mb-3'>
//                     <div className='action-icon'>
//                       <FaFileAlt size={24} />
//                     </div>
//                     <h3 className='inboxCount'>
//                       {Number(DashboardData?.data?.dashboard?.total_count) || '-'}
//                     </h3>
//                   </div>
//                   <h5 className='fw-semibold mb-1'>Total Cases</h5>
//                 </div>
//               </a>
//             </Link>
//           </div>
//           <div className='col-lg-3 col-md-6 my-2'>
//             <Link
//               to={{
//                 pathname: roleName?.toLowerCase()?.includes('ro')
//                   ? '/quick-account-opening'
//                   : '/new-cif-new-account',
//                 state: roleName.toLowerCase()?.includes('ro')
//                   ? '/completedAccount'
//                   : 'completedIndividual',
//               }}
//             >
//               <a className='quick-action-card card-green'>
//                 <div className='card-body'>
//                   <div className='d-flex justify-content-between align-items-center mb-3'>
//                     <div className='action-icon'>
//                       <AiOutlineFileDone size={24} />
//                     </div>
//                     <h3 className='inboxCount'>
//                       {Number(DashboardData?.data?.dashboard?.total_completed) || '-'}
//                     </h3>
//                   </div>
//                   <h5 className='fw-semibold mb-1'>Completed</h5>
//                 </div>
//               </a>
//             </Link>
//           </div>
//           {!roleName?.toLowerCase()?.includes('ro') && (
//             <div className='col-lg-3 col-md-6 my-2'>
//               <Link to={'/new-cif-new-account/rejected-account-lists'}>
//                 <a className='quick-action-card card-red'>
//                   <div className='card-body'>
//                     <div className='d-flex justify-content-between align-items-center mb-3'>
//                       <div className='action-icon'>
//                         <MdCancel size={24} />
//                       </div>
//                       <h3 className='inboxCount'>
//                         {Number(DashboardData?.data?.dashboard?.total_rejected) || '-'}
//                       </h3>
//                     </div>
//                     <h5 className='fw-semibold mb-1'>Rejected</h5>
//                   </div>
//                 </a>
//               </Link>
//             </div>
//           )}
//         </div>
//       </section>

//       {roleName === 'Branch Maker' && (
//         <section className='mb-4'>
//           <h3 className='title'>Branch Maker</h3>
//           <Divider className='m-0 mb-2' />
//           <div className='row'>
//             {Object?.entries(DashboardData?.data?.dashboard?.branch_maker)?.map(
//               ([key, value], index) => {
//                 return (
//                   <div className='col-lg-3 col-md-6 my-2'>
//                     <Link
//                       to={{
//                         pathname: '/new-cif-new-account',
//                         state: key?.toLowerCase() == 'corporate' && 'corporateBank',
//                       }}
//                     >
//                       <a className={`quick-action-card ${colors[index]} `}>
//                         <div className='card-body'>
//                           <div className='d-flex justify-content-between align-items-center mb-3'>
//                             <div className='action-icon'>
//                               {key?.toLowerCase() == 'individual' ? (
//                                 <IoPerson size={24} />
//                               ) : key?.toLowerCase() == 'joint' ? (
//                                 <MdGroup size={24} />
//                               ) : key?.toLowerCase() == 'minor' ? (
//                                 <BiChild size={24} />
//                               ) : (
//                                 <MdCorporateFare size={24} />
//                               )}
//                             </div>
//                             <h3 className='inboxCount'>{Number(value) || '-'}</h3>
//                           </div>
//                           <h5 className='fw-semibold mb-1 text-capitalize'>{key}</h5>
//                         </div>
//                       </a>
//                     </Link>
//                   </div>
//                 )
//               }
//             )}
//           </div>
//         </section>
//       )
//       }
//       {
//         roleName === 'Branch Checker' && (
//           <section className='mb-4'>
//             <h3 className='title'>Branch Checker</h3>
//             <Divider className='m-0 mb-2' />
//             <div className='row'>
//               {Object?.entries(DashboardData?.data?.dashboard?.branch_checker)?.map(
//                 ([key, value], index) => {
//                   return (
//                     <div className='col-lg-3 col-md-6 my-2'>
//                       <Link
//                         to={{
//                           pathname: '/new-cif-new-account',
//                           state: key?.toLowerCase() == 'corporate' && 'corporateBank',
//                         }}
//                       >
//                         <a className={`quick-action-card ${colors[index]} `}>
//                           <div className='card-body'>
//                             <div className='d-flex justify-content-between align-items-center mb-3'>
//                               <div className='action-icon'>
//                                 {key?.toLowerCase() == 'individual' ? (
//                                   <IoPerson size={24} />
//                                 ) : key?.toLowerCase() == 'joint' ? (
//                                   <MdGroup size={24} />
//                                 ) : key?.toLowerCase() == 'minor' ? (
//                                   <BiChild size={24} />
//                                 ) : (
//                                   <MdCorporateFare size={24} />
//                                 )}
//                               </div>
//                               <h3 className='inboxCount'>{Number(value) || '-'}</h3>
//                             </div>
//                             <h5 className='fw-semibold mb-1 text-capitalize'>{key}</h5>
//                           </div>
//                         </a>
//                       </Link>
//                     </div>
//                   )
//                 }
//               )}
//             </div>
//           </section>
//         )
//       }
//       {
//         roleName === 'Branch Manager' && (
//           <section className='mb-4'>
//             <h3 className='title'>Branch Manager</h3>
//             <Divider className='m-0 mb-2' />
//             <div className='row'>
//               {Object?.entries(DashboardData?.data?.dashboard?.branch_manager)?.map(
//                 ([key, value], index) => {
//                   return (
//                     <div className='col-lg-3 col-md-6 my-2'>
//                       <Link
//                         to={{
//                           pathname: '/new-cif-new-account',
//                           state: key?.toLowerCase() == 'corporate' && 'corporateBank',
//                         }}
//                       >
//                         <a className={`quick-action-card ${colors[index]} `}>
//                           <div className='card-body'>
//                             <div className='d-flex justify-content-between align-items-center mb-3'>
//                               <div className='action-icon'>
//                                 {key?.toLowerCase() == 'individual' ? (
//                                   <IoPerson size={24} />
//                                 ) : key?.toLowerCase() == 'joint' ? (
//                                   <MdGroup size={24} />
//                                 ) : key?.toLowerCase() == 'minor' ? (
//                                   <BiChild size={24} />
//                                 ) : (
//                                   <MdCorporateFare size={24} />
//                                 )}
//                               </div>
//                               <h3 className='inboxCount'>{Number(value) || '-'}</h3>
//                             </div>
//                             <h5 className='fw-semibold mb-1 text-capitalize'>{key}</h5>
//                           </div>
//                         </a>
//                       </Link>
//                     </div>
//                   )
//                 }
//               )}
//             </div>
//           </section>
//         )
//       }
//     </div >
//   )
// }

// export default CardComponent


import { Result, Spin } from 'antd'
import { Link } from 'react-router-dom'
import { FaFileAlt } from 'react-icons/fa'
import { IoPerson } from 'react-icons/io5'
import { MdCancel, MdCorporateFare, MdGroup } from 'react-icons/md'
import { BiChild } from 'react-icons/bi'
import { AiOutlineFileDone } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import { useGetDashboardData } from 'src/cms/hooks/Individual/useGetDashboardData'
import './style/DashBoardCard.scss'

// ── Brand tokens ─────────────────────────────────────────────────────
const NAVY = '#1a3282'
const RED = '#c8181a'

// ── Per-type icon + color config (logo brand colors) ─────────────────
const ACCOUNT_TYPE_CONFIG: Record<string, { icon: JSX.Element; color: string; bg: string }> = {
  individual: { icon: <IoPerson size={26} />, color: NAVY, bg: 'rgba(26,50,130,0.09)' },
  joint: { icon: <MdGroup size={26} />, color: RED, bg: 'rgba(200,24,26,0.09)' },
  minor: { icon: <BiChild size={26} />, color: NAVY, bg: 'rgba(26,50,130,0.09)' },
  corporate: { icon: <MdCorporateFare size={26} />, color: RED, bg: 'rgba(200,24,26,0.09)' },
}

// ── Generic stat card ─────────────────────────────────────────────────
interface StatCardProps {
  to: string | { pathname: string; state?: any }
  icon: JSX.Element
  count: any
  label: string
  color: string
  bg: string
}

const StatCard = ({ to, icon, count, label, color, bg }: StatCardProps) => (
  <Link to={to} style={{ textDecoration: 'none', display: 'block' }}>
    <div
      className='stat-card'
      style={{ '--stat-color': color, '--stat-bg': bg } as React.CSSProperties}
    >
      <div className='stat-icon'>{icon}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className='stat-count'>{count}</div>
        <div className='stat-label'>{label}</div>
      </div>
      <div className='stat-arrow'>›</div>
    </div>
  </Link>
)

// ── Section header (matches homepage .section-header) ─────────────────
const SectionHeader = ({ title }: { title: string }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
    <h3 style={{
      margin: 0,
      fontSize: '0.7rem',
      fontWeight: 800,
      color: NAVY,
      textTransform: 'uppercase',
      letterSpacing: '2.2px',
      whiteSpace: 'nowrap',
      paddingLeft: 10,
      borderLeft: `3px solid ${RED}`,
    }}>
      {title}
    </h3>
    <div style={{ flex: 1, height: 1, background: 'linear-gradient(to right, #dde3f5, transparent)' }} />
  </div>
)

// ── Branch breakdown section ──────────────────────────────────────────
const BranchSection = ({
  title,
  data,
  linkPath = '/new-cif-new-account',
}: {
  title: string
  data: Record<string, any>
  linkPath?: string
}) => (
  <section style={{ marginBottom: 28 }}>
    <SectionHeader title={title} />
    <div className='row'>
      {Object.entries(data).map(([key, value]) => {
        const cfg = ACCOUNT_TYPE_CONFIG[key.toLowerCase()] ?? ACCOUNT_TYPE_CONFIG.corporate
        return (
          <div key={key} className='col-lg-3 col-md-6 my-2'>
            <StatCard
              to={{ pathname: linkPath, state: key.toLowerCase() === 'corporate' ? 'corporateBank' : undefined }}
              icon={cfg.icon}
              count={Number(value) || '-'}
              label={key.charAt(0).toUpperCase() + key.slice(1)}
              color={cfg.color}
              bg={cfg.bg}
            />
          </div>
        )
      })}
    </div>
  </section>
)

// ── Main component ────────────────────────────────────────────────────
const CardComponent = () => {
  const roleName: string = useSelector((state: any) => state.auth?.rolePermissions?.name ?? '')
  const { data: DashboardData, isLoading } = useGetDashboardData('NewCIFNewAccount')

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <Spin tip='Loading...' size='large' />
      </div>
    )
  }

  if (!roleName) {
    return (
      <div className='card'>
        <div className='card-body pt-3'>
          <Result
            status='warning'
            title='Role Not Found'
            subTitle='Please contact Central Operation to assign your role.'
          />
        </div>
      </div>
    )
  }

  const { dashboard } = DashboardData.data
  const isRO = roleName.toLowerCase().includes('ro')

  const currentDate = new Date().toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  })

  return (
    <div>

      {/* ── Page header — text only, no card background ─────────────── */}
      <div style={{ padding: '10px 2px 28px', marginBottom: 8 }}>

        {/* Top row: date + role badge */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18, flexWrap: 'wrap', gap: 10 }}>
          <span style={{ fontSize: '0.68rem', fontWeight: 600, color: '#8fa3be', letterSpacing: '1.8px', textTransform: 'uppercase' }}>
            {currentDate}
          </span>
          {roleName && (
            <span style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              background: '#eef1fb', border: '1px solid rgba(26,50,130,.14)',
              color: NAVY, fontSize: '0.67rem', fontWeight: 700,
              padding: '4px 13px', borderRadius: 999,
              letterSpacing: '0.9px', textTransform: 'uppercase',
            }}>
              <span style={{ width: 5, height: 5, background: RED, borderRadius: '50%', flexShrink: 0 }} />
              {roleName}
            </span>
          )}
        </div>

        {/* Greeting + title */}
        <p style={{ margin: '0 0 6px', fontSize: '1rem', fontWeight: 400, color: '#4b5e8a' }}>
          Report Dashboard
        </p>
        <h2 style={{ margin: '0 0 20px', fontSize: '2.2rem', fontWeight: 800, color: NAVY, lineHeight: 1.15, letterSpacing: '-0.6px' }}>
          Branch Activity&nbsp;<span style={{ color: RED }}>Overview</span>
        </h2>

        {/* Decorative rule — red → navy gradient */}
        <div style={{ height: 2, width: 56, background: `linear-gradient(to right, ${RED}, ${NAVY})`, borderRadius: 2 }} />
      </div>

      {/* ── Branch Summary ────────────────────────────────────────────── */}
      <section style={{ marginBottom: 28 }}>
        <SectionHeader title='Branch Summary' />
        <div className='row'>

          <div className='col-lg-3 col-md-6 my-2'>
            <StatCard
              to={isRO ? '/quick-account-opening' : '/account-opening-status'}
              icon={<FaFileAlt size={22} />}
              count={Number(dashboard.total_count) || '-'}
              label='Total Cases'
              color={NAVY}
              bg='rgba(26,50,130,0.09)'
            />
          </div>

          <div className='col-lg-3 col-md-6 my-2'>
            <StatCard
              to={{ pathname: isRO ? '/quick-account-opening' : '/new-cif-new-account', state: isRO ? '/completedAccount' : 'completedIndividual' }}
              icon={<AiOutlineFileDone size={22} />}
              count={Number(dashboard.total_completed) || '-'}
              label='Completed'
              color='#10b981'
              bg='rgba(16,185,129,0.09)'
            />
          </div>

          {!isRO && (
            <div className='col-lg-3 col-md-6 my-2'>
              <StatCard
                to='/new-cif-new-account/rejected-account-lists'
                icon={<MdCancel size={22} />}
                count={Number(dashboard.total_rejected) || '-'}
                label='Rejected'
                color={RED}
                bg='rgba(200,24,26,0.09)'
              />
            </div>
          )}

          {!isRO && (
            <div className='col-lg-3 col-md-6 my-2'>
              <StatCard
                to='/summary-report'
                icon={<FaFileAlt size={22} />}
                count='›'
                label='Summary Report'
                color={NAVY}
                bg='rgba(26,50,130,0.09)'
              />
            </div>
          )}

        </div>
      </section>

      {/* ── Role-specific breakdown ───────────────────────────────────── */}
      {roleName === 'Branch Maker' && <BranchSection title='Branch Maker' data={dashboard.branch_maker} />}
      {roleName === 'Branch Checker' && <BranchSection title='Branch Checker' data={dashboard.branch_checker} />}
      {roleName === 'Branch Manager' && <BranchSection title='Branch Manager' data={dashboard.branch_manager} />}

    </div>
  )
}

export default CardComponent
